export interface CustomerActionTypes {
  type: CustomerActions;
  payload?: any;
}

export enum CustomerActions {
  CREATE_CUSTOMER = "CREATE_CUSTOMER",
  GET_CUSTOMER_LIST = "GET_CUSTOMER_LIST",
  SET_CUSTOMER_LIST = "SET_CUSTOMER_LIST",
  SET_CUSTOMER_LIST_PAGE_COUNT = "SET_CUSTOMER_LIST_PAGE_COUNT",
  GET_CUSTOMER_DATA_BY_ID = "GET_CUSTOMER_DATA_BY_ID",
  SET_CUSTOMER_DATA_BY_ID = "SET_CUSTOMER_DATA_BY_ID",
  EDIT_CUSTOMER_DETAILS = "EDIT_CUSTOMER_DETAILS",
}
